// src/store/authStore.js
import { create } from 'zustand';

const useAuthStore = create((set) => ({
  token: localStorage.getItem('rm_token') || null,
  admin: JSON.parse(localStorage.getItem('rm_admin') || 'null'),

  login: (token, admin) => {
    localStorage.setItem('rm_token', token);
    localStorage.setItem('rm_admin', JSON.stringify(admin));
    set({ token, admin });
  },

  logout: () => {
    localStorage.removeItem('rm_token');
    localStorage.removeItem('rm_admin');
    set({ token: null, admin: null });
  },

  isAuthenticated: () => !!localStorage.getItem('rm_token'),
}));

export default useAuthStore;
